import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// Utilities
import { scrollToSelector } from '@/shared/utilities';

// Pages
const Register = () => import('./pages/Register.vue');
const Login = () => import('./pages/Login.vue');
const RegisterName = () => import('./pages/RegisterName.vue');
const RegisterEmail = () => import('./pages/RegisterEmail.vue');
const RegisterPassword = () => import('./pages/RegisterPassword.vue');
const RegisterComplete = () => import('./pages/RegisterComplete.vue');
const NotFound = () => import('@/shared/pages/NotFound.vue');

export default new VueRouter({
  base: '/',
  mode: 'history',
  routes: [
    // Redirect as /account page has no content
    { path: '/account', redirect: '/account/login' },

    // Regular page routes
    { path: '/account', component: Register,
      children: [
        { path: 'login', component: Login },
        { path: 'register/name', component: RegisterName },
        { path: 'register/email', component: RegisterEmail },
        { path: 'register/password', component: RegisterPassword },
        { path: 'register/complete', component: RegisterComplete }
      ]
    },    

    // 404 page
    { path: '/404', component: NotFound },

    // 404 redirect
    { path: '*', redirect: to => {
      window.location.href = '/404';
    }}
  ],

  linkActiveClass: 'is-active',

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      // savedPosition is only available for popstate navigations.
      return savedPosition
    } else {
      // scroll to anchor from hash in url
      // enables smooth scrolling to anchors in page linked from router-view
      if (to.hash) {
        // Animated scroll to position
        scrollToSelector(to.hash);  
      }

      // Meta scrolling checks

      // Check for scroll to selector
      if (to.matched.some(m => m.meta.scrollToSelector)) {
        scrollToSelector(to.meta.scrollToSelector); 
      }

      // If route doesn't have scroll to selector, check for scroll to top meta
      else if (to.matched.some(m => m.meta.scrollToTop)) {
        scrollToSelector('body'); 
      }
    }
  }
});


// WEBPACK FOOTER //
// ./resources/assets/js/external/router.js